module.exports = __webpack_public_path__ + "Server-Healthy.TentaclePassive.26a256889e134db68a5550f09df1f588.hashedasset.svg";